module.exports = "/_next/static/images/ObserveYourData@2x-f29ab31263a4ca8f8cab0bfb896a0f78.webp";